module.exports = __webpack_public_path__ + "static/img/products discription_tunnel1.1ef0d454.jpg";